// @ts-nocheck

import { useEffect, useRef, useState } from "react";
import { gantt } from "dhtmlx-gantt";
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
import axios from "axios";
import { formatarDadosGantt } from "../../utils/formataTarefa";
import { SelectCenterCost } from "../../components/ViewTasks/SelectCenterCost";
// import { SelectBranch } from "../../components/ViewTasks/SelectBranch";
import {
  ArrowsOutLineHorizontal,
  PersonSimpleRun,
  Flag,
  HandPalm,
  HardHat,
  Sigma,
} from "@phosphor-icons/react";
import { Button } from "../../components/ui/button";

export function ViewTasks() {
  const ganttContainer = useRef(null);
  const [tarefas, setTarefas] = useState([]);
  const [centerCost, setCenterCost] = useState({});
  // const [branch, setBranch] = useState([]);
  const [status, setStatus] = useState({});
  const [reload, setReaload] = useState(false);

  // Configuração inicial do Gantt
  useEffect(() => {
    // Configurações básicas
    gantt.config.readonly = true;
    gantt.config.drag_move = false;
    gantt.config.drag_progress = false;
    gantt.config.drag_resize = false;
    gantt.config.drag_links = false;
    gantt.config.fit_tasks = true;
    gantt.config.date_format = "%Y-%m-%d %H:%i";
    gantt.config.scale_height = 30;
    gantt.config.min_column_width = 70;

    // Escala de tempo
    gantt.config.scales = [
      {
        unit: "minute",
        step: 10,
        format: (date) => {
          const hours = date.getHours().toString().padStart(2, "0");
          const minutes = date.getMinutes().toString().padStart(2, "0");
          return `${hours}:${minutes}`;
        },
      },
    ];

    // Colunas
    gantt.config.columns = [
      { name: "text", label: "Tarefa", tree: true, width: 200 },
      { name: "status", label: "Status", width: 100 },
      { name: "duration_planned", label: "Tempo Planejada", width: 120 },
    ];

    // Classes de status
    gantt.templates.task_class = (start, end, task) => {
      const statusClasses = {
        pending: "task-pending",
        started: "task-started",
        completed: "task-completed",
        cancelled: "task-cancelled",
        notdone: "task-notdone",
      };
      return statusClasses[task.status] || "task-id";
    };

    // Injetar CSS personalizado para a linha do tempo
    const style = document.createElement("style");
    style.textContent = `
      .time-line {
        position: absolute;
        top: 0;
        height: 100% !important;
        width: 2px;
        background-color: red;
        z-index: 1;
        pointer-events: none;
      }
      
      .gantt_task_bg {
        position: relative;
        overflow: visible !important;
      }
    `;
    document.head.appendChild(style);

    // Inicialização
    gantt.init(ganttContainer.current);

    // Configurar período de visualização
    const hoje = new Date();
    gantt.config.start_date = new Date(hoje.setHours(0, 0, 0));
    gantt.config.end_date = new Date(hoje.setHours(24, 0, 0));

    return () => {
      document.head.removeChild(style);
      gantt.clearAll();
    };
  }, [centerCost]);

  // Atualização de dados
  useEffect(() => {
    if (tarefas.length > 0) {
      gantt.parse({ data: tarefas });
      adjustTimelineAndScroll();
    }
  }, [tarefas]);

  // Busca de dados
  useEffect(() => {
    let urlQueryParamsCC = "";
    if (centerCost.hasOwnProperty("value")) {
      urlQueryParamsCC = `cost_center=${centerCost.value}`;
    }

    const queryParams = [urlQueryParamsCC].filter((param) => param !== "");

    const baseUrlCC = "https://radar.tlpservicos.com.br/api/toa/task-runner";
    const baseUrlStatus = "https://radar.tlpservicos.com.br/api/toa/stats";

    const fullUrlCC =
      queryParams.length > 0 ? `${baseUrlCC}?${queryParams.join("&")}` : baseUrlCC;

    const fullUrlStatus =
      queryParams.length > 0
        ? `${baseUrlStatus}?${queryParams.join("&")}`
        : baseUrlStatus;

    const fetchData = async () => {
      try {
        const { data } = await axios.get(fullUrlCC);
        const { data: dataStatus } = await axios.get(fullUrlStatus);
        setStatus(dataStatus);
        const { data: tarefasFormatadas } = formatarDadosGantt(data);
        setTarefas(tarefasFormatadas);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };

    fetchData();
  }, [centerCost]);

  // Funções auxiliares
  const adjustTimelineAndScroll = () => {
    const moveScrollBar = () => {
      const ganttScroll = document.querySelector(".gantt_hor_scroll");
      const mainContainer = document.querySelector(".gantt_container");
      if (ganttScroll && mainContainer) {
        mainContainer.parentNode.insertBefore(ganttScroll, mainContainer);
        Object.assign(ganttScroll.style, {
          width: "100%",
          height: "20px",
          marginBottom: "10px",
        });
      }
    };

    const updateTimeline = () => {
      const linhaAnterior = document.querySelector(".time-line");
      if (linhaAnterior) linhaAnterior.remove();

      const agora = new Date();
      const coluna = gantt.posFromDate(agora);
      const scrollLeft = gantt.$task_data.scrollLeft;

      const linha = document.createElement("div");
      linha.className = "time-line";
      linha.style.left = `${coluna - scrollLeft}px`;

      // Encontrar o container do Gantt e ajustar a altura da linha
      const ganttContainer = document.querySelector(".gantt_container");
      if (ganttContainer) {
        linha.style.height = `${ganttContainer.offsetHeight}px`;
      }

      const areaGantt = document.querySelector(".gantt_task_bg");
      if (areaGantt) {
        areaGantt.appendChild(linha);
        // Forçar um recálculo do layout
        areaGantt.style.position = "relative";
      }
    };

    const centerTimeline = () => {
      const agora = new Date();
      const coluna = gantt.posFromDate(agora);
      const containerWidth = gantt.$task.offsetWidth;
      gantt.scrollTo(coluna - containerWidth / 2, undefined);
    };

    moveScrollBar();
    updateTimeline();
    centerTimeline();

    // Atualizar a linha quando houver scroll
    gantt.attachEvent("onGanttScroll", updateTimeline);

    // Atualizar a linha quando o tamanho da janela mudar
    const handleResize = () => {
      setTimeout(updateTimeline, 100);
    };
    window.addEventListener("resize", handleResize);

    // Atualizar a cada minuto
    const intervalo = setInterval(updateTimeline, 60000);

    return () => {
      clearInterval(intervalo);
      window.removeEventListener("resize", handleResize);
      gantt.detachEvent("onGanttScroll");
    };
  };

  function handleRealodData() {
    setReaload((prev) => prev!);
  }

  return (
    <div>
      <div className="flex gap-4 p-5">
        <SelectCenterCost setCenterCost={setCenterCost} />
        {/* <SelectBranch setBranch={setBranch} /> */}
        {/* <Button onClick={handleRealodData}>Recarregar dados</Button> */}
      </div>
      <div className="flex flex-row w-full gap-2 mr-[50px]">
        <div className="flex flex-row justify-around items-center bg-zinc-800 w-1/6 rounded-md h-20">
          <ArrowsOutLineHorizontal className="h-8 w-8 text-orange-700 " weight="bold" />
          <div className="flex flex-col gap-2 items-center">
            <div className="text-gray-200">Abertas</div>
            <div className="text-white text-3xl">
              {status.hasOwnProperty("abertas") ? status.abertas : 0}
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-around items-center bg-zinc-800 w-1/6 rounded-md h-20">
          <PersonSimpleRun className="h-8 w-8 text-cyan-700" weight="bold" />
          <div className="flex flex-col gap-2 items-center">
            <div className="text-gray-200">Em Andamento</div>
            <div className="text-white text-3xl">
              {status.hasOwnProperty("andamento") ? status.andamento : 0}
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-around items-center bg-zinc-800 w-1/6 rounded-md h-20">
          <Flag className="h-8 w-8 text-green-700" weight="bold" />
          <div className="flex flex-col gap-2 items-center">
            <div className="text-gray-200">Concluídas</div>
            <div className="text-white text-3xl">
              {status.hasOwnProperty("concluidas") ? status.concluidas : 0}
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-around items-center bg-zinc-800 w-1/6 rounded-md h-20">
          <HandPalm className="h-8 w-8 text-red-700" weight="bold" />
          <div className="flex flex-col gap-2 items-center">
            <div className="text-gray-200">Pendenciadas</div>
            <div className="text-white text-3xl">
              {status.hasOwnProperty("pendenciadas") ? status.pendenciadas : 0}
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-around items-center bg-zinc-800 w-1/6 rounded-md h-20">
          <HardHat className="h-8 w-8 text-violet-700" weight="bold" />
          <div className="flex flex-col gap-2 items-center">
            <div className="text-gray-200">Técnicos Ativos</div>
            <div className="text-white text-3xl">
              {status.hasOwnProperty("tecnicos_ativos") ? status.tecnicos_ativos : 0}
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-around items-center bg-zinc-800 w-1/6 rounded-md h-20">
          <Sigma className="h-8 w-8 text-slate-600" weight="bold" />
          <div className="flex flex-col gap-2 items-center">
            <div className="text-gray-200">Total atividades</div>
            <div className="text-white text-3xl">
              {status.hasOwnProperty("total") ? status.total : 0}
            </div>
          </div>
        </div>
      </div>
      <div style={{ padding: "20px" }}>
        <div ref={ganttContainer} className="w-full h-screen" />
      </div>
    </div>
  );
}
